import { render, staticRenderFns } from "./sideClient.vue?vue&type=template&id=8a57a308&scoped=true"
import script from "./sideClient.vue?vue&type=script&lang=js"
export * from "./sideClient.vue?vue&type=script&lang=js"
import style0 from "./sideClient.vue?vue&type=style&index=0&id=8a57a308&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a57a308",
  null
  
)

export default component.exports